import React from 'react';
import styled from 'styled-components';
import { IConversationGrammar, IConversationVocabulary } from '@datatype/iyagigo/api-type';
import StudyNote from '@component/iyagigo/common/study-note';

interface IProps {
  vocabularies: IConversationVocabulary[] | null;
  grammars: IConversationGrammar[] | null;
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
`;

const ConversationNote: React.FC<IProps> = ({ vocabularies, grammars }) => (
  <Wrapper>
    <StudyNote vocabularies={vocabularies} grammars={grammars} />
  </Wrapper>
);

export default ConversationNote;
